var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[[_c('v-layout',{staticClass:"mainContainer"},[(_vm.$route && _vm.$route.name)?_c('v-layout',{class:_vm.isEmbedded ? 'mb-11' : 'd-block ' + _vm.$route.name},[_c('v-container',{staticClass:"pa-0 MainRouterContainer"},[_c('router-view')],1)],1):_vm._e()],1)],_c('snackbar',{ref:"snackbar"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }